export default {
    namespaced: true,
    state: {
        types: [
            { libelle: 'Enseigne', code: 'enseigne'},
            { libelle: 'Pré-enseigne', code: 'preenseigne'},
            { libelle: 'Publicité', code: 'publicite'},
        ],
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/Typologie/index.js